module.exports = __webpack_public_path__ + "img/clock_white.3ae02e8d.svg";